import { render } from "./CreateTourForm.vue?vue&type=template&id=650ba367"
import script from "./CreateTourForm.vue?vue&type=script&lang=js"
export * from "./CreateTourForm.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "650ba367"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('650ba367', script)) {
    api.reload('650ba367', script)
  }
  
  module.hot.accept("./CreateTourForm.vue?vue&type=template&id=650ba367", () => {
    api.rerender('650ba367', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CreateTourForm.vue"

export default script